export default {
    // payModel
    wechatpay: "WeChat Pay",
    card: "memberCard",
    alipay: "Alipay",
    wallet: "membership card",
    cash: "cash",
    pos: "swipe card",
    other: "Other",

    //channel
    miniProgram: "WeChat Mini Program",
    web: "computer web page",

    // status
    noPaid: "Not paid",
    notConfirmed: "Pending payment",
    confirmed: "To be used",
    closed: "closed",
    completed: "Completed",
    canceled: "Cancelled"
};
